// 通用编码映射关系配置
export const COMMON_SETTING = {
  // 通用实验分组 - key 实验分组, value 枚举值
  AB_STRATEGY: {
    a: 'a',
    b: 'b',
    c: 'c',
    d: 'd',
    e: 'e',
    f: 'f',
    g: 'g',
    h: 'h',
    i: 'i',
    j: 'j',
    k: 'k',
    l: 'l',
    defaultStrategyKey: '1',
    off: '2',
  },
  // 通用实验策略 - key 实验策略, value 枚举值
  AB_SWITCH: {
    true: '1',
    false: '2',
    true_dsp: '3',
    false_dsp: '4',
    true_csrssr: '5',
    false_csrssr: '6',
    '': '7',
  },
  // 通用实验来源 - key 实验来源, value 枚举值
  AB_FROM: { ehc: '1', prefetch: '2' },
};